import { Box, Container } from "@mui/material";
import React from "react";
import { Route, Routes } from "react-router-dom";

import FAQ from "@/pages/utilities/help/faq/FAQ/FAQ";
import Feedback from "@/pages/utilities/help/feedback/Feedback/Feedback";

interface TabPanelProps {
  children?: React.ReactNode;
}

function TabPanel(props: TabPanelProps) {
  const { children, ...other } = props;

  return (
    <Box sx={{ pt: 0 }} {...other}>
      {children}
    </Box>
  );
}

const Help: React.FC = () => {
  return (
    <Container disableGutters maxWidth={false}>
      <Box sx={{ width: "100%", mt: 0 }}>
        <Routes>
          <Route path="/" element={<FAQ />} />
          <Route
            path="faq"
            element={
              <TabPanel>
                <FAQ />
              </TabPanel>
            }
          />
          <Route
            path="feedback"
            element={
              <TabPanel>
                <Feedback />
              </TabPanel>
            }
          />
        </Routes>
      </Box>
    </Container>
  );
};

export default Help;
